export function getApiErrorMessage(err, fallback = 'Произошла ошибка') {
  const errorData = err?.response?.data
  const nestedData = errorData?.data
  const details = nestedData?.details || errorData?.details

  if (details && typeof details === 'object') {
    const messages = []

    for (const [field, fieldError] of Object.entries(details)) {
      const text = Array.isArray(fieldError)
        ? fieldError.find(item => item != null && item !== '')
        : fieldError

      if (text == null || text === '') continue
      messages.push(field ? `${field}: ${text}` : String(text))
    }

    if (messages.length > 0) return messages.join('. ')
  }

  return (
    nestedData?.message ||
    errorData?.message ||
    err?.message ||
    fallback
  )
}
